var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"res"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('me.res.title')))]),_c('div',{staticClass:"cards"},_vm._l((_vm.getReses),function(r,i){return _c('div',{key:i,staticClass:"card"},[_c('blue-shadow2'),_c('res-info-card',{attrs:{"res":r,"size":i===0? 'l' : 'm',"id":r.resId,"from":"/me/res"}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }